export enum RequestStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  FAILED = 'failed',
  SUCCESS = 'success',
  FORBIDDEN = 'forbidden',
  UPLOAD_FAILED = 'uploadFailed',
}
